
const animate = _throttle(()=>{
	const q = document.querySelectorAll('[data-aos].aos-visible:not(.aos-animate)')

	if( q.length > 0 ){
		q[0].classList.add('aos-animate')
	}

	if( q.length > 1 ){
		animate()
	}
}, 50, { leading: false })


const aos = function (next) {

	const aosElements = next.querySelectorAll('[data-aos]')

	if (aosElements.length < 1)
		return // didn't find any, exiting...

	let options = {
		rootMargin: '0px 0px -16px 0px',
		threshold: 0
	}

	const aosObserver = new IntersectionObserver(els => {
		els.forEach(el => {
			const element = el.target

			if (el.isIntersecting) {
				element.classList.add('aos-visible')
				aosObserver.unobserve(element)
			}

			animate()
		});
	}, options);

	aosElements.forEach(el => {
		el.classList.remove('aos-visible', 'aos-animate')
		aosObserver.observe(el)
		el.classList.add('aos-ready')
	})

	document.documentElement.classList.remove('aos-loading')

}

export default aos
